const { parseObject, generateObjectImageUrls } = require("./objectDataUtils");

module.exports = {
  parseObject,
  generateObjectImageUrls,
};
